import {
  EntityStoryQueue,
  InternalDataObject,
  ResponseData,
} from "@api/internal/utils/types";
import { TagType } from "@pages/Section/types";
import { FeedSection } from "@src/app/pages/Section/utils/types";

export enum FieldKey {
  Description = "description",
  MetaTitle = "metaTitle",
  MetaDescription = "metaDescription",
  Displayname = "displayName",
  ImageDescriptionLogo = "image:descriptionLogo",
  Template = "template",
  StoryQueues = "storyQueue",
  Id = "id",
  Source = "source",
  Sourceid = "sourceid",
  ModifiedAt = "modifiedAt",
  CreatedAt = "createdAt",
}

export type FeedTagResponseData = ResponseData<FeedTagData>;

export type FeedTag = {
  id: string;
  name: string;
  type: TagType;
  urlPath: string;
  sections?: FeedSection[];
};

export type FeedTagEntity = {
  tag: FeedTag;
  template?: string;
  storyQueue?: EntityStoryQueue[];
};

export type FeedTagData = InternalDataObject<FeedTagEntity>;
